import React, { useRef } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getContacts,
  selectContacts,
  setIsInViewport,
} from "../../redux/reducers/slice/common";
import * as GTM from "../tracking/GTM";
import "./style.scss";
import { useIsInViewport } from "../../hooks/useIsInViewport";

const ContactUs = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const contacts = useSelector(selectContacts);

  const ref = useRef<HTMLDivElement>(null);
  const isInViewport = useIsInViewport(ref);

  useEffect(() => {
    dispatch(setIsInViewport("ContactUs", isInViewport));
  }, [isInViewport]);

  useEffect(() => {
    if (!contacts) {
      dispatch(getContacts());
    }
  }, []);

  const handleClick = (contact: any) => {
    if (contact.type === "live") {
      GTM.trackingEventDynamic("clickFBCustomerChat");
    } else if (contact.type === "phone") {
      GTM.trackingEventDynamic("clickContactHotline");
    }
    if (contact.type === "live") {
      window.open(contact.url);
    } else {
      window.location.href = contact.url;
    }
  };

  return (
    <div className="contact-us-wrapper" ref={ref}>
      <div className="contact-us-item-wrapper">
        <span className="large-title">{t("contact_us_title")}</span>
      </div>
      <div className="contact-us-item-wrapper">
        {contacts &&
          contacts.length &&
          contacts.map((item: any, index: number) => (
            <a
              key={index}
              className={`contact-us-item-wrap ${
                item.type === "email" ? "item-content-email" : ""
              }`}
              // href={item.url}
              onClick={() => handleClick(item)}>
              <img src={item.images.path} alt="" />
              <span className="item-title sub-title">{item.title}</span>
              <span className="item-work-time main-content">
                {item.content}
              </span>
            </a>
          ))}
      </div>
    </div>
  );
};

export default ContactUs;
